<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-ruble-sign text-success" lab="ポイント発行" @do_click="toMakePoint"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-qrcode text-danger" lab="法人を招待する" @do_click="toInviteSearch('0')"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-building text-danger" lab="招待した法人" @do_click="toInviteSearch('1')"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-qrcode text-primary" lab="個人を招待する" @do_click="toTechInviteCode"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-users text-primary" lab="招待した個人" @do_click="toTechInvitedList"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-people-arrows text-primary" lab="個人営業招待" @do_click="toSalesInviteCode"></page-nav>
            </div>
            <div class="col-sm-4 mb-2">
                <page-nav icn="fas fa-file text-primary" lab="履歴書一覧" @do_click="toTechResume"></page-nav>
            </div>
        </div>
    </div>
</template>

<script>
    import PageNav from 'pages/commons/nav/PageNav'

    export default {
        components: {
            PageNav
        },
        methods: {
            toMakePoint () {
                this.$router.push({name: 'MakePoint'})
            },
            toInviteSearch (id) {
                this.$router.push({name: 'InviteSearch', params: {
                    id: id 
                }})
            },
            toTechInviteCode () {
                this.$router.push({name: 'InviteCode', params: {
                    type: '0', // m-p
                    group: 'none'
                } })
            },
            toSalesInviteCode () {
                this.$router.push({name: 'InviteCodeSales'})
            },
            toTechInvitedList () {
                this.$store.dispatch('setRefreshArr', 'techLevel')
                //this.$store.dispatch('resetTechLevel')
                this.$router.push({name: 'TechLevel'})
            },
            toTechResume () {
                this.$store.dispatch('setRefreshArr', 'techResume')
                this.$router.push({name: 'TechResume'})
            }
        }
    }
</script>

<style lang="stylus" scoped>

</style>
